(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const updateVideoButton = (video, playing) => {
    const card = video.closest('.cc-card__media');
    const button = card?.querySelector('[data-cc-video-toggle]');
    if (!button) return;
    const label = video.getAttribute('aria-label') || 'video';
    button.dataset.playing = playing ? 'true' : 'false';
    button.textContent = playing ? 'Ⅱ' : '▶';
    button.setAttribute('aria-label', `${playing ? 'Pause' : 'Play'} ${label}`);
  };

  const loadVideo = (video, shouldPlay = false) => {
    if (!video.src && video.dataset.ccVideoSrc) {
      video.src = video.dataset.ccVideoSrc;
      video.load();
    }
    if (!shouldPlay) return;
    video.play().catch(() => updateVideoButton(video, false));
  };

  const setupVideos = (root) => {
    const videos = Array.from(root.querySelectorAll('video[data-cc-video-src]'));
    if (!videos.length) return;

    videos.forEach((video) => {
      video.addEventListener('play', () => updateVideoButton(video, true));
      video.addEventListener('pause', () => updateVideoButton(video, false));
      updateVideoButton(video, false);
    });

    root.addEventListener('click', (event) => {
      const button = event.target.closest('[data-cc-video-toggle]');
      if (!button) return;
      const video = button.closest('.cc-card__media')?.querySelector('video');
      if (!video) return;
      loadVideo(video);
      if (video.paused) {
        video.play().catch(() => updateVideoButton(video, false));
      } else {
        video.pause();
      }
    });

    if (!('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting) {
          loadVideo(video, !reducedMotion.matches);
        } else if (!video.paused) {
          video.pause();
        }
      });
    }, { rootMargin: '260px 0px', threshold: 0.15 });

    videos.forEach((video) => observer.observe(video));
  };

  const setupFeatureMaps = (root) => {
    root.querySelectorAll('[data-cc-feature-map]').forEach((map) => {
      map.addEventListener('click', (event) => {
        const tab = event.target.closest('[data-cc-feature-tab]');
        if (!tab) return;
        const panelId = tab.dataset.ccFeatureTab;
        map.querySelectorAll('[data-cc-feature-tab]').forEach((item) => {
          const active = item === tab;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        map.querySelectorAll('[data-cc-feature-panel]').forEach((panel) => {
          panel.hidden = panel.id !== panelId;
        });
      });
    });
  };

  const setupUsps = (root) => {
    const details = Array.from(root.querySelectorAll('.cc-usp__details'));
    if (!details.length) return;

    details.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        details.forEach((other) => {
          if (other !== item) other.removeAttribute('open');
        });
      });
    });

    root.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const openItem = details.find((item) => item.open);
      if (!openItem) return;
      openItem.removeAttribute('open');
      openItem.querySelector('summary')?.focus();
    });
  };

  const init = (scope = document) => {
    scope.querySelectorAll('[data-cc-landing]:not([data-cc-ready])').forEach((root) => {
      root.dataset.ccReady = 'true';
      setupVideos(root);
      setupFeatureMaps(root);
      setupUsps(root);
    });
  };

  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
